<template>
  <!-- <div class="imger">
    <img src="./img/login/Logo@2x.png" class="logo">
    <label class="logo_span">江苏狄诺尼</label>

    <el-carousel indicator-position="outside" style="background:red;width:41.66667%;">
      <el-carousel-item v-for="item in 4" :key="item" style="background:yellow;">

        <h3>{{ item }}</h3>
      </el-carousel-item>
    </el-carousel>

  </div> -->
  <div style="min-width:1000px;height:100%">
    <el-row style="height:100%;">
      <el-col :span="9" style="height:100%;">
        <div class="imger imger1" >
          <img src="./img/login/Logo@2x.png" class="logo">
          <label class="logo_span">江苏狄诺尼</label>

          <el-carousel indicator-position="outside" class="lbt" style="height:calc(100% - 100px);">
            <el-carousel-item v-for="(item,index) in lbt" :key="index" style="height:100%;">
              <img class="lbt_img" :src="item.imgUrl" />
              <div class="lbt_div">
                <label class="lbt_title">{{item.title}}</label></br>
                <div style="height:18px;"></div>
                <span class="lbt_span">{{item.text}}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="15" style="height: 100%">
        <div class="imger imger2">
          <a href="http://www.jsdnn.com/" target="_blank"><span  class="fwgw">访问官网 →</span></a>
          <el-card class="box-card logins" style="width:540px;height:486px;">
            <div class="login_div">
              <span class="login_span">用户登录</span>
              <el-form style="text-align:center;" :model="loginForm" :rules="rules2" ref="loginForm">
                <el-form-item prop="phone" class="phone">
                  <span class="iconfont icon-weibiaoti-" style="font-size:20px;"></span>
                  <el-input class="phone_input" style="height:60px;" type="text"  v-model="loginForm.phone"  auto-complete="off" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item prop="password" class="phone password">
                  <span class="iconfont icon-mima1" style="font-size:20px;"></span>
                  <el-input class="phone_input"  type="password" style="height:60px;" auto-complete="off" placeholder="密码" 
                   v-model="loginForm.password" @keyup.enter.native="handleSubmit2" ></el-input>
                </el-form-item>
               <!-- <el-form-item style="width:100%;" class="phone password"> -->
                  <el-button type="danger" class="login_submit" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
                <!-- </el-form-item> -->
              </el-form>
              <div class="tips">
                <router-link  :to="{path:'/applyOn'}" >申请试用</router-link>
                <router-link  :to="{path:'/register'}" >免费注册</router-link>
                <router-link  :to="{path:'/forget'}" >忘记密码</router-link>
              </div>
            </div>
          </el-card>
          <div class="span_bottom">
            <span style="line-height:30px;">
              江苏狄诺尼信息技术有限责任公司 
            </span></br>
            <span>
              CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  import { requestLogin } from '../api/api';
  export default {
    data() {
      return{
        radio: 3,
        logining: false,
        loginForm: {
          phone: '',
          password: ''
        },
        rules2: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        checked: true,
        num:'',
        lbt:[
          {
            imgUrl:'./static/img/login/banner1@2x.png',
            title:'EICAD',
            text:'集成交互道路与立交系统 EICAD路线平面设计中，提供了智能化“路中线”实体。用户可以直接拖拽路中线上的各个夹点，以修改交点位置、圆曲线半径、缓和曲线长度、切线长和外距等设计参数，操作过程所见即所得。设计者可以忘记以往众多的设计功能命令，随心所欲地拖动调整，如同摆弄桌面上的一根绳索。'
          },
          {
            imgUrl:'./static/img/login/banner2@2x.png',
            title:'数字地面模型系统 EIDTM',
            text:'数字地面模型EIDTM模块是一个专门用于采集地形散点和等高线数据，构成三角网格，实现纵横断面剖切、地面高程坡度查询等数模应用的子系统。该模块旨在为道路工程设计者提供一套快捷、智能智能化、自动化的地形数字化及应用解决方案。软件能够在极短的时间内完成地形数字化、构网和实时剖切计算，极大的提高了数字化地形的应用效率。',
          },
          {
            imgUrl:'./static/img/login/banner3@2x.png',
            title:'BIM自动建模',
            text:'EIBIM软件提出了“线路信息模型”（Route Information Modeling）的基本实现架构，并实现了其技术途径。在EICAD模型成果的基础上，导出线路信息模型数据，利用Revit二次开发工具，实现道路信息模型的无缝转换、同步更新；并建立公路工程常用桥隧BIM构件库；开发桥隧工程的自动建模功能。EIBIM从根本上解决了上述难题。',
          }
        ],
      }
    },
    methods: {
      handleSubmit2(formName) {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.login();
          } else {
            this.$message.error('请正确输入登录账号和密码..');
            return false;
          }
        });
      },
      // 登录
      login() {
        this.logining = true;
        let param ={
          password:this.loginForm.password,
          phone:this.loginForm.phone,
          userType:'0',//用户类型
        }
        API__login.login(param)
        .then( (res) => {
          if( res.data.code == API__code.SUCCESS ) {
            sessionStorage.clear();
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('module');
            this.setCookie("dnnyptInfo","dnnypt_checkCode","");
            this.setCookie("dnnyptInfo","dnnypt_id","");
            this.clearCookie();
            this.$message({
              message: '登录成功',
              type: 'success'
            });
            if(res.data.data.checkCode){
              var checkCode = res.data.data.checkCode
              this.setCookie("dnnyptInfo","dnnypt_checkCode",checkCode);
            }
            if(res.data.data.id){
              var id = res.data.data.id;
              // this.setCookie("dnnyptInfo","dnnypt_id",id);
              sessionStorage.setItem('dnnypt_id', id);
            }
            if(res.data.data.phone){
              var token = res.data.data.phone;
              this.setCookie("dnnyptInfo","dnnypt_token",token);
              this.$store.commit('set_token', token);
            }
            if(res.data.data.company){
              var company = res.data.data.company;
              sessionStorage.setItem('company', company);
            }
            if(res.data.data.photo ){
              var photo = res.data.data.photo;
              sessionStorage.setItem('photo', photo);
            }
            if(res.data.data.point || res.data.data.point ==0){
              var point = res.data.data.point;
              sessionStorage.setItem('point', point);
            }
            if(res.data.data.name){
              var name = res.data.data.name;
              sessionStorage.setItem('user', name);
            }else{
              if(res.data.data.phone){
                var token = res.data.data.phone;
                sessionStorage.setItem('user', token);
              }
            }
            if(res.data.data.module){
              var modules = res.data.data.module;
              sessionStorage.setItem('module', modules);
            }
            if(res.data.data.companyuseid){
              sessionStorage.setItem('companyuseid', res.data.data.companyuseid);
            }
            this.$router.push({path: 'management'});
          }else {
            this.$message.error(res.data.message);
          }
          this.logining = false;
        }).catch( e => {
          this.$message.error('服务器异常，请您稍后再试..');
          this.logining  = false;
        });
      },
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
        var exdate = new Date(); //获取时间
        exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
        if(c_name == "dnnyptInfo"){
          window.document.cookie = c_pwd + "=" + exdays + ";path=/;expires=" + exdate.toGMTString();
        }else{
          //字符串拼接cookie
          window.document.cookie = "name" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
          window.document.cookie = "password" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        }
      },
     
      //清除cookie
      clearCookie: function() {
          this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },
    },
    mounted(){
    },
    created(){
     
    }
  }
</script>
<style scoped>
.fwgw{
  color:#F66B3D;
  font-size:16px;
  position:relative;
  float:right;
  right:60px;
  top:33px;
}
.lbt{
  position: relative;
  left: 50%;
  top:100px;
  -webkit-transform: translate(-50%,0);
  -ms-transform: translate(-50%,0);
  transform: translate(-50%,0);
}
.imger{
  height:100%;
  width: 100%;
  background-size: cover;
}
.imger1{    
  background:  url('./img/login/BG2@2x.png');
}
.imger2{  
  background:  url('./img/login/BG1@2x.png');
  background-size: 100%;
}
.logo{
  width: 32px;
  height: 32px;
  position: absolute;
  left: 42px;
  top: 32px;
}
.logo_span{
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  left: 85px;
  top: 35px;
  font-family: "思源黑体 CN Bold Bold";
}
.logins{
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.login_span{
  font-weight: bold;
  font-size: 24px;
  font-family: "思源黑体 CN Bold Bold";
  color:#F66B3D;
}
.login_div{
  text-align:center;
  position: relative;
  top:25px;
}
.phone{
  width:400px;
  height: 60px;
  margin: 0 auto;
  font-size: 16px;
  position: relative;
  top: 45px;
}
.phone_input{
  width:400px;
  height: 60px;
  font-size: 16px;
}
.password{
  padding-top: 20px;
}
.login_submit{
  background-color:#F66B3D;width: 400px;
  background-color: rgb(246, 107, 61);
  height: 60px;
  position: relative;
  top: 90px;
  font-size: 20px;
  font-weight: Normal;
  font-family: "思源黑体 CN Bold Bold";
}
.tips {
    float: right;
    margin: 30px 50px 0 0;
    position: relative;
    top: 85px;
    font-size: 14px;
    color:#666666;
}
.tips a {
    color: #666;
    margin-left: 20px;
    cursor: pointer;
}
.lbt_img{
  width:500px;
  height:500px;
  clear: both; 
  display: block; 
  margin:auto; 
}
.lbt_div{
  text-align:center;
  width:82%;
  position:relative;
  left:9%;
}
.lbt_span{
  line-height: 24px;
  font-size: 14px;
  font-weight: normal;
  font-family: "思源黑体 CN Normal";
  color: #fff;
}
.lbt_title{
  line-height: 42px;
  font-size: 28px;
  font-weight: bold;
  font-family: "思源黑体 CN Normal";
  padding-bottom: 18px;
  color: #fff;
}
.span_bottom{
  text-align:center;
  bottom: 30px;
  position: absolute;
  font-size:14px;
  color:#666666;
  text-align: center;
  width: 62.5%;
}
</style>


// WEBPACK FOOTER //
// Login.vue?0da64c98